export enum PremiumServiceEventTypes {
  EventBased = "Event Based",
  AppAccess = "App Access",
  ConciergeEvent = "Concierge Event",
  Gift = "Gift",
  ByAppointment = "By appointment",
  Request = "Request",
  Event = "Event",
  Product = "Product"
}

export enum PremiumServiceEventTypeEnum {
  EventBased = "Event Based",
  ConciergeEvent = "Concierge Event",
  Event = "Event",
}

export enum PremiumServiceRequestTypeEnum {
  AppAccess = "App Access",
  ByAppointment = "By appointment",
  Request = "Request",
}

export enum PremiumServiceProductTypeEnum {
  Gift = "Gift",
  Product = "Product"
}